import { render, staticRenderFns } from "./contentCategoryActive.vue?vue&type=template&id=6df59425&"
import script from "./contentCategoryActive.vue?vue&type=script&lang=js&"
export * from "./contentCategoryActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports